module.exports = __webpack_public_path__ + "static/media/chaitanya.be3e5a92.jpg";